import { GraphQLEnumType } from 'graphql'

export type VulnerabilityOrderField =
  | 'NAME'
  | 'APPLICATION'
  | 'LAST_DETECTED'
  | 'FIRST_DETECTED'
  | 'STATUS'
  | 'SEVERITY'

export const vulnerabilityOrderFieldType = new GraphQLEnumType({
  name: 'VulnerabilityOrderField',
  description: 'Directions to sort a list of vulnerabilities',
  values: {
    NAME: {
      description: 'Order vulnerabilities by name'
    },
    APPLICATION: {
      description: 'Order vulnerabilities by related application name'
    },
    LAST_DETECTED: {
      description: 'Order vulnerabilities by last detection date'
    },
    FIRST_DETECTED: {
      description: 'Order vulnerabilities by first detected date'
    },
    STATUS: {
      description: 'Order vulnerabilities by status'
    },
    SEVERITY: {
      description: 'Order vulnerabilities by severity'
    }
  }
})
